var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"icon-box flex items-center justify-center",class:_vm.className},[_c('i',{staticClass:"weight-normal iconfont",class:_vm.iconName})])
}
var staticRenderFns = []

export { render, staticRenderFns }